export default __webpack_public_path__ + "static/media/grafema_design-factory-kitchen-pictograms_06.9d56e12e.jpg";